// extracted by mini-css-extract-plugin
export default {"spacer":"FlexSpacer__spacer___QU8it"};